"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import MenuItemView from '../../../../../../views/MenuItemView.mjs';
import 'invariant';
import 'luxon';
import 'react-aria-components';
import 'clsx';
import '../../../../../../lib/propsContext/propsContext.mjs';
import '../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import '@mittwald/react-tunnel';
import '../../../../../../lib/slotContext/slotContext.mjs';
import '@react-aria/utils';
import 'remeda';
import 'dot-prop';
import '@tabler/icons-react';
import '../../../../../Icon/Icon.mjs';
import '../../../../../Heading/Heading.mjs';
import '../../../../../Text/Text.mjs';
import 'react-aria';
import '../../../../../Button/Button.mjs';
import '../../../../../ContextMenu/ContextMenu.mjs';
import '../../../../../MenuItem/MenuItem.mjs';
import '../../../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import '../../../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import '../../../../../ColumnLayout/ColumnLayout.mjs';
import '../../../ListSummary/ListSummary.mjs';
import { useList } from '../../../../hooks/useList.mjs';
import '../../../../List.mjs';

const SortingMenuItem = (props) => {
  const { sorting } = props;
  const list = useList();
  return /* @__PURE__ */ jsx(
    MenuItemView,
    {
      id: sorting.id,
      onAction: () => {
        list.getSorting(sorting.id).enable();
      },
      children: sorting.name ?? sorting.property
    }
  );
};

export { SortingMenuItem };
//# sourceMappingURL=SortingMenuItem.mjs.map
